import 'sticky-sidebar';

export default function ($interval, donationsService) {
  let vm;

  class HomeController {
    constructor () {
      vm = this;
      vm.details = {};
      vm.priceList = [50, 100, 250, 500, 750, 1000, 1500, 2000];
      vm.modalBoxShown = true;
    }

    $onInit () {
      vm.getDonations();

      let time = 180000; // 3 minutes
      $interval(() => {
        vm.getDonations();
      }, time);
      setTimeout(setupStickySidebar, 1000);
    }

    getDonations () {
      donationsService.getDonations();
    }

    noNameChange () {
      if (vm.details.noName) {
        vm.details.donor = '';
      }
    }

    selectSuggestion (price) {
      vm.details.amount = price;
      $('#amount').focus();
    }

    openNedarimForm () {
      vm.donationActionClicked = true;
      if (vm.form.donor.$invalid) {
        return;
      }

      let mosad = '5775792';
      let donor = encodeURIComponent(vm.details.donor || 'אנונימי');
      let amount = encodeURIComponent(Math.max(0, vm.details.amount) || '');
      let group = encodeURIComponent('מגינים על המגן שלנו');
      let redirectPage = encodeURIComponent((location.href.split('#')[0]).replace(/^https?:\/\//, '') + '#!/thanks');

      let url = `https://www.matara.pro/nedarimplus/online/?mosad=${mosad}&Analytic=${donor}&groupe=${group}&Amount=${amount}&Redirect=${redirectPage}`;
      window.location.href = url;
    }

    scrollTop () {
      $('html,body').animate({ scrollTop: 0 }, 600);
    }
  }

  return new HomeController();
}

function setupStickySidebar () {
  var sidebar = new window.StickySidebar('.left-part', {
    innerWrapperSelector: '.left-part-inner',
    topSpacing: 14,
    bottomSpacing: 0
  });
  return sidebar;
}



// WEBPACK FOOTER //
// ./client/app/components/home/home.controller.js